export default __webpack_public_path__ + "static/media/first.19ebab8c.png";